















import { IBanner } from '~/types/banner';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PromoBanner extends Vue {
  @Prop() banners!: IBanner[];

  clicked() {
    if (this.activeBanner) {
      if (this.activeBanner.externalLink) {
        window.location.href = this.activeBanner.externalLink;
      } else if (this.activeBanner.internalRoute) {
        if (this.activeBanner.internalRoute.startsWith('/')) {
          this.$router.push(this.activeBanner.internalRoute);
        } else {
          // Hack - temporary fix because we don't have a proper way to specify an external link in our Sanity schema
          window.location.href = this.activeBanner.internalRoute;
        }
      }
    }
  }

  get activeBanner() {
    return this.banners[0]; // undefined is fine if array empty
  }
}
